import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentsService } from 'src/app/pages/documents/documents.service';
import { UsersService } from 'src/app/pages/users/users.service';
import { COMMERCIAL_AGREEMENTS_UPLOAD_MODALS } from 'src/app/shared/constants/constants';
import { CommercialAgreementFileParams } from 'src/app/shared/interfaces/commercial-agreements-parameters';
import { ApiRequestsService } from 'src/app/shared/services/api-requests.service';
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
})
export class UploadComponent implements OnInit {
  form: FormGroup = new FormGroup({
    archive: new FormControl(null, Validators.required),
  });
  @Input() type: 'readjustment' | 'create' | null = null;
  @Output() modalDismissed: EventEmitter<string> = new EventEmitter<string>();
  @Output() modalClosed: EventEmitter<string> = new EventEmitter<string>();
  disableButton: boolean = true;
  title: string = '';
  constructor(
    private documentsService: DocumentsService,
    private usersService: UsersService,
    private apiService: ApiRequestsService
  ) {}
  ngOnInit(): void {
    this.title =
      this.type === 'readjustment'
        ? COMMERCIAL_AGREEMENTS_UPLOAD_MODALS.masiveReadjustment.title
        : COMMERCIAL_AGREEMENTS_UPLOAD_MODALS.masiveUpload.title;
  }

  submit() {
    let subfix: string =
      this.type === 'readjustment' ? '_ca_readjustment' : '_ca_creation';
    this.documentsService
      .uploadCommercialAgreementsExcel(
        this.form.value.archive,
        Date.now().toString(),
        this.usersService.business.value.toUpperCase(),
        this.usersService.getActiveUser().email,
        subfix
      )
      .then(() => {
        this.c('load complete');
      })
      .catch((error) => {
        console.log('ERROR: ', error);
      });
  }

  onChangeImageFile(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files!.length > 0) {
      const file: File = target.files![0];
      this.form.get('archive')?.setValue(file);
      // Creamos un lector de archivos local.
      const fileReader: FileReader = new FileReader();
      fileReader.onload = (): void => {};
      fileReader.onloadend = (): void => {
        //activa el botton una vez que el archivo se cargo completamente.
        this.disableButton = false;
      };
    }
  }

  dwonloadReajusment() {
    const today = new Date();
    const selectedMonth = today.toISOString().slice(0, 7); // YYYY-MM

    const parameters: CommercialAgreementFileParams = {
      business: this.usersService.business.value.toUpperCase(),
      date: selectedMonth,
      license_plate: '',
      sap_id: '',
      carrier: '',
      center: '',
      status: '',
      readjustment: true,
    };

    this.apiService.downloadExcelCommercialAgreements(parameters);
  }

  /**
   * Función de desecho del modal.
   * @param {string} value Tecla con que fue desechado.
   */
  d(value: string): void {
    this.modalDismissed.emit(value);
  }

  /**
   * Función de cierre del modal.
   * @param {string} value Tecla con que fue cerrado.
   */
  c(value: string): void {
    this.modalClosed.emit(value);
  }
}
